// ExcelUploader.jsx - Main component
import React, { useState } from 'react'
import FileUploadArea from './FileUploadArea'
import DataPreview from './DataPreview'
import ProcessingStatus from './ProcessingStatus'
import { processExcelFile } from './excelProcessor'
import { ANALYTICS_EVENTS } from '../../analytics/events'
import useTrackedSurface from '../../analytics/useTrackedSurface'

function ExcelUploader() {
    const [studentsData, setStudentsData] = useState([])
    const [staffData, setStaffData] = useState([])
    const [sheetNames, setSheetNames] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)
    const onboardingStep = isLoading ? 'processing' : studentsData.length || staffData.length ? 'preview' : 'file'
    const onboardingStepLabels = { file: 'Upload file', processing: 'Processing file', preview: 'Data preview' }
    useTrackedSurface(ANALYTICS_EVENTS.ONBOARDING_STEP_VIEWED, {
        contentId: onboardingStep,
        content: onboardingStepLabels[onboardingStep],
    })

    const handleFileProcessing = async (file) => {
        if (!file) return

        setIsLoading(true)
        setError(null)
        setStudentsData([])
        setStaffData([])

        try {
            const result = await processExcelFile(file)

            setSheetNames(result.processedSheets)
            setStudentsData(result.studentsData || [])
            setStaffData(result.staffData || [])

            if (!result.studentsData?.length && !result.staffData?.length) {
                setError('Could not identify any student or staff data in the Excel file.')
            }
        } catch (err) {
            console.error('Error processing file:', err)
            setError(`Failed to process the Excel file: ${err.message}`)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="max-w-6xl mx-auto p-6">
            <h2 className="text-2xl font-bold mb-6 text-gray-800">School Data Upload</h2>

            <FileUploadArea onFileSelected={handleFileProcessing} />

            <ProcessingStatus isLoading={isLoading} error={error} sheetNames={sheetNames} />

            {studentsData.length > 0 && <DataPreview data={studentsData} title="Students Data" className="mt-6" />}

            {staffData.length > 0 && <DataPreview data={staffData} title="Staff Data" className="mt-10" />}
        </div>
    )
}

export default ExcelUploader
